import React from "react";
import { Box, FormControlLabel, Switch, useTheme } from "@mui/material";
import { useTranslation } from "react-i18next";
import InputCst from "@components/InputCst/InputCst";
import { WizardStepProps } from "@components/WizardCst/types";
import { ActivityWizardData } from "../../../../types";

const UrlResContent: React.FC<WizardStepProps<ActivityWizardData>> = ({
  data,
  setData,
  errors,
}) => {
  const { t } = useTranslation("wizard-activity");
  const theme = useTheme();

  const errMsg = (key: string): string =>
    errors[key] ? t(`errors.${errors[key]}`, { value: 32 }) || "" : "";

  return (
    <Box sx={{ display: "flex", flexDirection: "column", gap: 2 }}>
      <InputCst
        id="activity-url-res"
        label={`${t("content.url-res.url")} *`}
        value={data.external_file_url}
        onChange={(e: any) => setData({ external_file_url: e.target.value })}
        placeholder={
          data.is_link_relative
            ? t("content.url-res.placeholder-relative") || ""
            : t("content.url-res.placeholder-absolute") || ""
        }
        error={!!errors.external_file_url}
        errorMessage={errMsg("external_file_url")}
      />

      <FormControlLabel
        sx={{ color: theme.palette.text.primary }}
        control={
          <Switch
            checked={data.is_link_relative}
            onChange={(_, checked) => setData({ is_link_relative: checked })}
          />
        }
        label={t("content.url-res.is-link-relative")}
      />
      <FormControlLabel
        sx={{ color: theme.palette.text.primary }}
        control={
          <Switch
            checked={data.completion_required}
            onChange={(_, checked) => setData({ completion_required: checked })}
          />
        }
        label={t("content.url-res.completion-required")}
      />
    </Box>
  );
};

export default UrlResContent;
